<script setup lang="ts">
import type { KsoPayControl } from "../ksoPayControls";

defineProps<{ control: KsoPayControl }>();
</script>

<template
	>{{ control.text }}</template
>
